export const environment = {
    DISCOUNT_BRANDS_FILE_URL: null,
    PRODUCT_CATEGORIES_FILE_URL: null,
    REST_ENDPOINT: 'https://staging-backend.fashion.cloud',
    LOCATION_SERVICE_URL: 'https://staging-backend.fashion.cloud/location-service',
    CRM_SERVICE_URL: 'https://staging-backend.fashion.cloud/crm-service',
    DIM_ADMIN_API_URL: 'https://dim-admin-api.staging.fashion.cloud',
    PD_OBSERVER_URL: 'https://pd-observer.staging.fashion.cloud',
    SEGMENT_ENABLED: 'TRUE',
    SEGMENT_KEY: 'uSMKJDYuJOwmIYoJOaTJvvFY6KF9RN8F', // gitleaks:allow
    USERCENTRICS_SETTINGS_ID: 'ExBTOhsk7',
    USERCENTRICS_DRAFT_PREVIEW_ENABLED: false,
    USER_BRAND_VISIBILITY_FILE_URL: null,
    ORGANIZATION_FEATURE_FLAGS_FILE_URL: null,
    CATEGORIES_CONFIGURATION_FILE_URL: null,
    AMS_STACK_MAINTENANCE_FILE_URL: null,
    FLAGSMITH_ENVIRONEMT_ID: 'nqSLx4j8ij2DuKN7aQPAVS', // gitleaks:allow
    FLAGSMITH_URL: 'https://flagsmith-api.fashion.cloud/api/v1/',
    CUBEJS_URL: 'https://cube.staging.fashionexchange.nl',
    ORDER_WRITER_SERVICES: {
        catalog: 'https://catalog.staging.fashionexchange.nl',
        contract: 'https://contract.staging.fashionexchange.nl',
        sales: 'https://sales.staging.fashionexchange.nl',
        user: 'https://users.staging.fashionexchange.nl',
        masterdata: 'https://masterdata.staging.fashionexchange.nl'
    },
    production: true,
    beta: false,
    DD_ENABLED: true,
    DD_RUM_ENABLED: true,
    DD_SESSION_SAMPLE_RATE: 100,
    DD_SESSION_REPLAY_SAMPLE_RATE: 100,
    DD_TRACE_SAMPLE_RATE: 100,
    DD_ALLOWED_TRACING_URLS: ['https://staging.fashion.cloud', 'https://staging-backend.fashion.cloud/'],
    DD_ENV: 'staging',
    DD_CLIENT_TOKEN: 'pub00fdea68a25e53c6d1009e82a055c165', // gitleaks:allow
    DD_SITE: 'datadoghq.com',
    DD_APPLICATION_ID: '4f699963-186a-4ffe-b9db-37dc971af8c8',
    VERSION: process.env.APP_VERSION,
    auth0: {
        domain: 'auth.staging.fashion.cloud',
        clientId: '5WN7DlrHzGKKHRQ3wlGbaghunUpSlQPX', // gitleaks:allow
        authorizationParams: {
            audience: 'https://staging-backend.fashion.cloud/'
        }
    }
};
